var Education = "Eğitim";
var Enterprise = "Kurumsal";
var CompanyType = {
	"Company type": "Şirket Türü",
	Education: Education,
	Enterprise: Enterprise,
	"Government - Federal": "Devlet - Federal",
	"Government - State & local": "Devlet - Şehir ve Yerel",
	"Non-profit": "Kâr Amacı Gütmeyen",
	"Self employed": "Serbest Çalışan",
	"Small-medium business": "Küçük-Orta Ölçekli İşletme",
	"Start-up": "Startup",
	"Not applicable": "Geçerli Değil"
};

export { Education, Enterprise, CompanyType as default };
